import {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {isWithinPoland} from "@pg-mono/geo-utils";
import {appendQueryString} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable302ResponseState, enableErrorResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";
import {RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {fetchRcnAddress} from "../api/fetch_rcn_address";
import {fetchRegionsByCoordinates, IRegionByCoordinates} from "../api/fetch_regions_by_coordinates";
import {PRICES_ADDRESS_UNAVAILABLE_PARAM} from "../constants/prices_address_unavailable_param";
import {IPricesAddress, IPricesAddressRegion} from "../types/IPricesAddress";
import {IPricesAddressRouteParams} from "../types/IPricesAddressRouteParams";
import {parsePricesAddressPath} from "../utils/parse_prices_address_path";
import {formatRcnAddressName} from "../utils/prices_search/format_rcn_display_name";
import {fetchPriceReportRegion} from "./fetch_price_report_region";

const FETCH_PRICES_ADDRESS = "reports/FETCH_PRICES_ADDRESS";
export const fetchPricesAddressTypes = createRequestActionTypes(FETCH_PRICES_ADDRESS);

const toAddressRegion = (region: IRegionByCoordinates): IPricesAddressRegion => ({
    id: region.id,
    name: region.name,
    short_name: region.type === RegionType.CITY ? region.short_name : region.name,
    slug: region.slug,
    name_declension_what: region.name_declension_what,
    name_declension_where: region.name_declension_where
});

// A caught error is `unknown`, while notifyBugsnagClient takes its own error shape.
const notifyRequestError = (error: unknown, errorInfo: string) =>
    notifyBugsnagClient({message: String(error), error: error instanceof Error ? error : undefined}, errorInfo);

export const getPricesAddressUnavailableUrl = () => appendQueryString(rpAppPath.prices.flats.base, {[PRICES_ADDRESS_UNAVAILABLE_PARAM]: 1});

export const fetchPricesAddress = (ctx: IFetchContext<IRPRequestMeta, IPricesAddressRouteParams>) => async (dispatch: Dispatch) => {
    dispatch({type: fetchPricesAddressTypes.start});

    const rcnAddress = parsePricesAddressPath(ctx.route.pathname);
    if (!rcnAddress) {
        dispatch(rpEnable404ResponseState(ctx.route.pathname));
        return false;
    }

    let catalogAddress;
    try {
        catalogAddress = await fetchRcnAddress(ctx.meta, rcnAddress);
    } catch (error) {
        notifyRequestError(error, "fetch_prices_address: RCN address catalog");
        dispatch(enableErrorResponseState(503));
        return false;
    }
    const lat = catalogAddress?.representative_latitude;
    const lng = catalogAddress?.representative_longitude;
    if (typeof lat !== "number" || typeof lng !== "number" || !Number.isFinite(lat) || !Number.isFinite(lng) || !isWithinPoland(lat, lng)) {
        dispatch(enable302ResponseState(getPricesAddressUnavailableUrl()));
        return false;
    }

    let regions: IRegionByCoordinates[];
    try {
        regions = await fetchRegionsByCoordinates(ctx.meta, lat, lng);
    } catch (error) {
        notifyRequestError(error, "fetch_prices_address: regions by coordinates");
        dispatch(enableErrorResponseState(503));
        return false;
    }

    const city = regions.find((region) => region.type === RegionType.CITY);
    const district = regions.find((region) => region.type === RegionType.DISTRICT) ?? null;
    const estate = regions.find((region) => region.type === RegionType.NEIGHBORHOOD) ?? null;

    if (!city || !PRICES_CITIES_SLUGS.includes(city.slug)) {
        dispatch(enable302ResponseState(getPricesAddressUnavailableUrl()));

        return false;
    }

    const address: IPricesAddress = {
        rcnAddress,
        slug: ctx.route.pathname.slice(rpAppPath.prices.flats.base.length, -1),
        name: formatRcnAddressName(rcnAddress),
        lat,
        lng,
        estate: estate ? toAddressRegion(estate) : null,
        district: district ? toAddressRegion(district) : null,
        city: toAddressRegion(city)
    };

    dispatch({type: fetchPricesAddressTypes.success, result: address});

    return address;
};

export const fetchPricesAddressRegion = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
    const address = getState().report.price.address;
    if (!address) {
        return false;
    }
    return fetchPriceReportRegion({...ctx, match: {...ctx.match, params: {regionSlug: address.city.slug}}})(dispatch);
};
import {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {IFetchContext} from "@pg-mono/data-fetcher";
import {isWithinPoland} from "@pg-mono/geo-utils";
import {appendQueryString} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {enable302ResponseState, enableErrorResponseState} from "@pg-mono/response-state";
import {rpAppPath} from "@pg-mono/rp-routes";
import {RegionType} from "@pg-rp/common-types";
import {PRICES_CITIES_SLUGS} from "@pg-rp/navigation";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {rpEnable404ResponseState} from "../../../errors/actions/rp_enable_404_response_state";
import {fetchRcnAddress} from "../api/fetch_rcn_address";
import {fetchRegionsByCoordinates, IRegionByCoordinates} from "../api/fetch_regions_by_coordinates";
import {PRICES_ADDRESS_UNAVAILABLE_PARAM} from "../constants/prices_address_unavailable_param";
import {IPricesAddress, IPricesAddressRegion} from "../types/IPricesAddress";
import {IPricesAddressRouteParams} from "../types/IPricesAddressRouteParams";
import {parsePricesAddressPath} from "../utils/parse_prices_address_path";
import {formatRcnAddressName} from "../utils/prices_search/format_rcn_display_name";
import {fetchPriceReportRegion} from "./fetch_price_report_region";

const FETCH_PRICES_ADDRESS = "reports/FETCH_PRICES_ADDRESS";
export const fetchPricesAddressTypes = createRequestActionTypes(FETCH_PRICES_ADDRESS);

const toAddressRegion = (region: IRegionByCoordinates): IPricesAddressRegion => ({
    id: region.id,
    name: region.name,
    short_name: region.type === RegionType.CITY ? region.short_name : region.name,
    slug: region.slug,
    name_declension_what: region.name_declension_what,
    name_declension_where: region.name_declension_where
});

// A caught error is `unknown`, while notifyBugsnagClient takes its own error shape.
const notifyRequestError = (error: unknown, errorInfo: string) =>
    notifyBugsnagClient({message: String(error), error: error instanceof Error ? error : undefined}, errorInfo);

export const getPricesAddressUnavailableUrl = () => appendQueryString(rpAppPath.prices.flats.base, {[PRICES_ADDRESS_UNAVAILABLE_PARAM]: 1});

export const fetchPricesAddress = (ctx: IFetchContext<IRPRequestMeta, IPricesAddressRouteParams>) => async (dispatch: Dispatch) => {
    dispatch({type: fetchPricesAddressTypes.start});

    const rcnAddress = parsePricesAddressPath(ctx.route.pathname);
    if (!rcnAddress) {
        dispatch(rpEnable404ResponseState(ctx.route.pathname));
        return false;
    }

    let catalogAddress;
    try {
        catalogAddress = await fetchRcnAddress(ctx.meta, rcnAddress);
    } catch (error) {
        notifyRequestError(error, "fetch_prices_address: RCN address catalog");
        dispatch(enableErrorResponseState(503));
        return false;
    }
    const lat = catalogAddress?.representative_latitude;
    const lng = catalogAddress?.representative_longitude;
    if (typeof lat !== "number" || typeof lng !== "number" || !Number.isFinite(lat) || !Number.isFinite(lng) || !isWithinPoland(lat, lng)) {
        dispatch(enable302ResponseState(getPricesAddressUnavailableUrl()));
        return false;
    }

    let regions: IRegionByCoordinates[];
    try {
        regions = await fetchRegionsByCoordinates(ctx.meta, lat, lng);
    } catch (error) {
        notifyRequestError(error, "fetch_prices_address: regions by coordinates");
        dispatch(enableErrorResponseState(503));
        return false;
    }

    const city = regions.find((region) => region.type === RegionType.CITY);
    const district = regions.find((region) => region.type === RegionType.DISTRICT) ?? null;
    const estate = regions.find((region) => region.type === RegionType.NEIGHBORHOOD) ?? null;

    if (!city || !PRICES_CITIES_SLUGS.includes(city.slug)) {
        dispatch(enable302ResponseState(getPricesAddressUnavailableUrl()));

        return false;
    }

    const address: IPricesAddress = {
        rcnAddress,
        slug: ctx.route.pathname.slice(rpAppPath.prices.flats.base.length, -1),
        name: formatRcnAddressName(rcnAddress),
        lat,
        lng,
        estate: estate ? toAddressRegion(estate) : null,
        district: district ? toAddressRegion(district) : null,
        city: toAddressRegion(city)
    };

    dispatch({type: fetchPricesAddressTypes.success, result: address});

    return address;
};

export const fetchPricesAddressRegion = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
    const address = getState().report.price.address;
    if (!address) {
        return false;
    }
    return fetchPriceReportRegion({...ctx, match: {...ctx.match, params: {regionSlug: address.city.slug}}})(dispatch);
};
